export default __webpack_public_path__ + "static/media/print.d0c5f647.svg";